import { ReactComponent as BgHalf } from '../assets/home/half-bg.svg';
import BadgeScreenShot from '../assets/badges.png';
import HomeScreenShot from '../assets/home.png';
import { ReactComponent as FullBadge } from '../assets/badge-full.svg';
import { ReactComponent as OutlineBadge } from '../assets/badge-outline.svg';
import { ReactComponent as IOSDownload } from '../assets/ios.svg';
const Home = () => {
    return (
        <div className="container">
            <div className="content">
                <FullBadge id='full-primary' />
                <OutlineBadge id='outline-primary' />
                <OutlineBadge id='outline-gold' />
                <div className="header">
                    <h1>Habts</h1>
                    <h2>Our habits define who we are, so lets build good ones.</h2>
                    <a href='https://apps.apple.com/us/app/apple-store/id1556105093'>
                        <IOSDownload id='ios-download' />
                    </a>
                </div>
                <div className="images">
                    <div id="badge-screenshot">
                        <img src={BadgeScreenShot} alt='badges' />
                    </div>

                    <div id="home-screenshot">
                        <img src={HomeScreenShot} alt='home screen shot' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;